export default "__VITE_ASSET__xtKLY0ex__"